<!--
 * @Author: gzm
 * @Date: 2021-06-16 16:48:49
 * @Description:代码管理
-->
<template>
  <div class="wrap-box">
      <div class="top">
          <el-header class="top-header">
              <div class="header-content">
                  <h3 class="header-content-title">代码管理&nbsp;&nbsp;</h3>
              </div>
          </el-header>
          <cs-code-management></cs-code-management>
      </div>
  </div>
</template>

<script>
import CsCodeManagement from '@/components/Comencapsulation/cs-codemanagement';
export default {
  data () {
      return {
      };
  },

  components: {
    CsCodeManagement
  },

  computed: {},

  mounted () {},

  methods: {}
};

</script>
<style lang='scss' scoped>
.top{
   overflow: auto;
   margin-bottom: 20px;
   height: 100vh;
   .top-header{
       padding-left: 15px;
   }
}
</style>



// WEBPACK FOOTER //
// ./src/views/CsCodeManagement.vue